import { BloodworkNote } from '.';
import { legacyNamesFor } from './Section';

export class BloodworkNotes {
  notes?: BloodworkNote[]; 

  constructor(bloodworkNotes?: BloodworkNotes | any) {
    if (bloodworkNotes && bloodworkNotes.notes) {
      this.notes = bloodworkNotes.notes;
    } else {
      this.notes = [];
    }
  }

  /**
   * A note is stored under its section's DISPLAY name, so renaming a section
   * would otherwise blank out every note already typed under it. Falls back to
   * the names that section used to print under (see LEGACY_SECTION_NAMES).
   *
   * Read-side only: the found note keeps whatever `section` it was saved with,
   * so editing it updates that row in place rather than leaving two. Exact
   * matches win, so a note typed since the rename is never shadowed by an
   * older one.
   */
  findNote(section: string): BloodworkNote {
    const exact = this.notes.find((note)=>{
      return note.section === section;
    })
    if (exact) {
      return exact;
    }
    const legacy = legacyNamesFor(section);
    return legacy.length
      ? this.notes.find(note => legacy.includes(note.section as string))
      : undefined;
  }

  addNote(section: string, text: string): BloodworkNote {
    const bloodworkNote = new BloodworkNote({ section, text });
    this.notes.push(bloodworkNote);
    return bloodworkNote;
  }
}
